import gql from 'graphql-tag';
import { apolloQuery, BaseModel, QueryResult } from 'vue-apollo-model';
import { Query } from '@/generated-models';
import { transformText } from '@/common/util/parseText';
import { photoResultFragment } from '@/common/fragments/photoResultFragment';
import { getCookie } from '@/common/cookie';
const firstRecoTimeFlag = 'daily-first-reco';
/**
 * new reco feed model 新版视频页feed流信息
 */
export default class NewRecoFeedModel extends BaseModel {
    currentIndex = 0;
    lastFeedEndIndex = 0;
    dailyFirstPage = false;
    @apolloQuery<NewRecoFeedModel>({
        query: gql`
        ${photoResultFragment}
        query visionNewRecoFeed(
            $semKeyword: String,
            $semCrowd: String,
            $utmSource: String, 
            $utmMedium: String,
            $utmCampaign: String,
            $dailyFirstPage: Boolean
        ){
            visionNewRecoFeed(
                semKeyword: $semKeyword,
                semCrowd: $semCrowd,
                utmSource: $utmSource,
                utmMedium: $utmMedium,
                utmCampaign: $utmCampaign,
                dailyFirstPage: $dailyFirstPage
            ){
                ...photoResult
            }
        }
        `,
        variables($route) {
            // 处理每自然日未登录用户首刷推荐页场景识别和优化，需求team https://team.corp.kuaishou.com/task/T3590602
            const userId = getCookie('userId') || '';
            // 未登录情况下才判断今日是否有请求过推荐页，已登录情况则不用处理
            if (!userId) {
                const isDailyFirst = Number(localStorage.getItem(firstRecoTimeFlag) ?? '');
                if (isDailyFirst) {
                    const startTime = (new Date(isDailyFirst)).setHours(0, 0, 0, 0);
                    const endTime = (new Date(isDailyFirst)).setHours(23, 59, 59, 999);
                    const curTime = Date.now();
                    if (curTime < startTime || curTime > endTime) {
                        this.dailyFirstPage = true;
                        localStorage.setItem(firstRecoTimeFlag, `${Date.now()}`);
                    }
                } else {
                    this.dailyFirstPage = true;
                    localStorage.setItem(firstRecoTimeFlag, `${Date.now()}`);
                }
            }
            return {
                semKeyword: $route.query.keyword,
                semCrowd: $route.query.renqun_youhua,
                utmSource: $route.query.utm_source,
                utmMedium: $route.query.utm_medium,
                utmCampaign: $route.query.utm_campaign,
                dailyFirstPage: this.dailyFirstPage,
            };
        },
    })
    newRecoFeed!: QueryResult<{
        visionNewRecoFeed: Query['visionNewRecoFeed'];
    }>

    get feedVideoList() {
        const list = this.newRecoFeed.data.visionNewRecoFeed?.feeds?.map((feed, index) => {
            if (feed?.photo?.caption && this.lastFeedEndIndex <= index) {
                feed.photo.caption = transformText(feed?.photo?.caption as string);
            }
            return feed;
        }) || [];
        this.lastFeedEndIndex = list.length;
        return list;
    }

    get feedVideoListLength() {
        return this.newRecoFeed.data.visionNewRecoFeed?.feeds?.length || 0;
    }

    get llsid() {
        return this.newRecoFeed.data.visionNewRecoFeed?.llsid;
    }

    async getMoreFeedList() {
        if (this.newRecoFeed.loading) {
            return;
        }
        await this.newRecoFeed.fetchMore({
            variables: {
                dailyFirstPage: false,
            },
            updateQuery: (prev, next) => {
                return {
                    visionNewRecoFeed: {
                        ...(next?.visionNewRecoFeed || {}),
                        feeds: [
                            ...(prev.visionNewRecoFeed?.feeds || []),
                            ...(next?.visionNewRecoFeed?.feeds || []),
                        ],
                    },
                };
            },
        });
    }

    updateVideoLike(index: number, liked: boolean, count: number) {
        const feed = this.feedVideoList[index];
        if (feed && feed.photo) {
            feed.photo.liked = liked;
            feed.photo.realLikeCount = count;
        }
    }

    updateAuthorFollow(index: number, followed: boolean) {
        const feed = this.feedVideoList[index];
        if (feed && feed.author) {
            feed.author.following = followed;
        }
    }
}
